export const RECEIPT_TAGS = {
  REPROCESS_MANUAL_REJECT_TAG: "ManualReject",
  REPROCESS_CHECK_FRAUD: "ToCheckFraud",
  REPROCESS_MANUAL_ACCEPT_TAG: "ManualAccept",
  REPROCESS_MANUAL_GIVE_STAMPS_PREFIX_TAG: "ManualGiveStamps_",
  REPROCESS_MANUAL_GIVE_POINTS_PREFIX_TAG: "ManualGiveStamps_",
  REPROCESS_TAG: "ToReprocess",
  REPROCESS_SUCCESS_TAG: "ReprocessSuccess",
  REPROCESS_FAIL_TAG: "ReprocessFail",
  NOT_RECOGNIZABLE_TAG: "NotRecognizable",
  STAMPS_RECEIVED_TAG: "StampsReceived",
  POINTS_RECEIVED_TAG: "PointsReceived",
  VERIFY_DUPLICATE_TAG: "VerifyDuplicate",
  SUSPECT_DUPLICATE_TAG: "SuspectDuplicate",
  SUSPECT_LOCATION_TAG: "SuspectLocation",
  TIME_CONSTRAINT_NOT_VALID: "TimeConstraintNotValid",
  CURRENCY_CONSTRAINT_NOT_PASS: "CurrencyConstraintNotPass",
  NOT_ELIGIBLE_TAG: "NotEligible",
  INCOMPLETE_TAG: "Incomplete",
  NOT_ENOUGH_STAMPS: "NotEnoughStamps",
  MANUAL_VERIFY_TAG: "ToManualVerify",
  CONSUMPTION_LIMIT_REACHED_TAG: "ConsumptionLimitReached",
  POINTS_LIMIT_REACHED_TAG: "PointsLimitReached",
  STAMPS_LIMIT_REACHED_TAG: "StampsLimitReached",
  PUNCHCARD_ALREADY_COMPLETED_TAG: "PunchcardAlreadyCompleted",
  MANUAL_REVIEW_LIMIT_EXCEEDED_TAG: "ManualReviewLimitExceeded"
}
